import { render } from "./ClientQuoteReject.vue?vue&type=template&id=725fd7e4"
import script from "./ClientQuoteReject.vue?vue&type=script&lang=js"
export * from "./ClientQuoteReject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__